<!--操作福利有关的组件抽取 职位和企业都需要-->
<template>
  <div class="welfares">
    <el-tag
      v-for="(welfare, index) in welfareList"
      :key="index"
      :closable="userInfo['auditStatus'] != 1 && isAbleOprate != '0'"
      :disable-transitions="false"
      size="default"
      @close="toClose(welfare)"
    >
      {{ welfare }}
    </el-tag>
    <el-input
      v-if="inputVisible"
      ref="saveTagInput"
      v-model="inputWelfare"
      :maxlength="10"
      size="small"
      class="input-new-tag"
      @blur="confirmInput"
    />
    <el-button
      v-show="userInfo['auditStatus'] != 1 && isAbleOprate != '0'"
      icon="el-icon-plus"
      class="button-new-tag"
      circle
      size="small"
      @click="showInput"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    parentWelfareList: {
      type: Array,
      default() {
        return []
      }
    },
    // 0，不能够操作，比如职位正在审核中
    isAbleOprate: {
      type: String,
      default() {
        return '1'
      }
    }
  },
  data() {
    return {
      welfareList: [],
      inputWelfare: '',
      inputVisible: false
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.base.userInfo
    })
  },
  watch: {
    parentWelfareList(value) {
      this.welfareList = value
    }
  },

  created() {
    this.welfareList = this.parentWelfareList
  },
  methods: {
    /// /////////////////////////////////////////////////////福利
    // 1,关闭福利框
    toClose(welfare) {
      this.welfareList.splice(this.welfareList.indexOf(welfare), 1)
    },
    // 2,显示输入框
    showInput() {
      this.inputVisible = true
      this.$nextTick((_) => {
        // 获取到增加标签的值
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    // 重置输入框
    toResetInput() {
      this.inputVisible = false
      this.inputWelfare = ''
    },
    // 3,确认输入
    confirmInput() {
      let inputWelfare = this.inputWelfare
      if (this.welfareList.indexOf(this.inputWelfare) > -1) {
        this.$message.warning('福利标签不能够重复')
        // 清除重复的，重写填写福利
        this.toResetInput()
        return
      }
      if (inputWelfare) {
        this.welfareList.push(inputWelfare)
      }
      this.toResetInput()
    }
  }
}
</script>
<style lang="scss" scoped>
.welfares {
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
  }
  .input-new-tag {
    width: 120px;
    margin-left: 10px;
  }

}
</style>



// WEBPACK FOOTER //
// src/model/oprateWelfare.vue